import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import isRetina from 'is-retina';


import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStar, faBars, faTimes} from '@fortawesome/fontawesome-free-solid'

import logoSm from '../assets/images/logo-sm.png'
import logo2x from '../assets/images/logo-white_2x.png'
import logoSmColor from '../assets/images/logo-sm_color.png'
import logoSmColor2x from '../assets/images/logo_2x.png'



export default class Navbar extends Component{
    constructor(props){
        super(props);
        this.state = {
            isScroll: false,
            location: "",
            load: true,
            isMenuPopUp: false         
        }
        this.handleScroll = this.handleScroll.bind(this)
        this.handleLoad = this.handleLoad.bind(this)
        this.handleClick = this.handleClick.bind(this)
    }    
    componentDidMount(){
        window.addEventListener('scroll', this.handleScroll);   
        document.onreadystatechange()           
    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        this.setState({
            load: true
        })        
    }
    
    handleScroll(e){
        let html = document.getElementsByTagName('html')[0],
            windowHeight = (html.scrollTop / html.offsetHeight ) * 100,        
            isTrue = windowHeight > 2 ? true : false

        this.setState(prevState => ({
            isScroll: isTrue
        }))
    }

    handleLoad(){           
        document.onreadystatechange = () => {                 
            if(document.readyState === "complete"){                
                this.setState({
                    load: false
                })                
            }            
        }    
    }

    handleClick(e){
        const target = e.target;
        const name = target.name ? target.name : target.dataset.name;
        const value = target.dataset.value        
        this.setState(prevState => ({
            [name]: !prevState[name]
        }))

    }
    render(){
        const   {isDefault, isTextBlack} = this.props,
                {isScroll, load, isMenuPopUp} = this.state,  
                {handleLoad, handleClick} = this        
        handleLoad()
        const logoColor = isRetina() ? logoSmColor2x:logoSmColor
        const logo = isRetina() ? logoSm:logoSm
        return(
            <div id="navbar">  
            {load && <div className="pace"></div>}                
            <header id="header" className={isDefault ? ( isScroll ? 'nav-scroll' : `${isTextBlack ? 'clr-black' : ''}`) : `bg-white ${isScroll ? 'nav-scroll' : ''}` }>
                <div className={isDefault ? "container":"container bg-white"}>
                    <Link to={"/"}>
                        <img src={isDefault ? ((isScroll || isTextBlack) ? logoColor : logo) : logoColor} className="logo_white" alt="logo" style={{height: '32px'}}/>
                    </Link>
                    <div className={`menu-dropdown ${isScroll ? 'clr-black': ''}`} data-name="isMenuPopUp" onClick={handleClick}>
                        <FontAwesomeIcon icon={faBars} />
                    </div>
                    {isMenuPopUp && 
                        <div className="navbar-popup">
                            <div className="btn-close" data-name="isMenuPopUp" onClick={handleClick}>
                                <FontAwesomeIcon icon={faTimes} />
                            </div>
                            <div className="navbar-popup_header">
                                <div>Menu</div>                                
                            </div>
                            <ul>
                                <li>
                                    <Link to={'/im-influencer'}>I’M INFLUENCER</Link>
                                </li>
                                <li>
                                    <Link to={'/features'}>FEATURES</Link>
                                </li>
                                <li>
                                    <Link to={'/pricing'}>PRICING</Link>
                                </li>
                                <li>
                                    <Link to={'/awards'}>AWARDS</Link>
                                </li>
                                <li>
                                    <Link to={'/guide'}>GUIDE 101</Link>
                                </li>                                
                            </ul>
                            <div className="navbar-popup_footer">                            
                                <Link to={'/login'}><button className="btn btn-small bg-white" >LOGIN</button></Link>                                
                                <Link to={'/signup'}><button className="btn btn-small bg-green">DAFTAR</button></Link>                                
                            </div>
                        </div>
                    }
                    <nav>
                        <ul>
                            <li>
                                <Link to={'/im-influencer'}>I’M INFLUENCER</Link>
                            </li>
                            <li>
                                <Link to={'/features'}>FEATURES</Link>
                            </li>
                            <li>
                                <Link to={'/pricing'}>PRICING</Link>
                            </li>
                            <li>
                                <Link to={'/awards'}>AWARDS</Link>
                            </li>
                            <li>
                                <Link to={'/guide'}>GUIDE 101</Link>
                            </li>
                            <li>
                                <Link to={'/login'}><button className={(isDefault && !isTextBlack) ? "btn btn-small" : "btn btn-small bg-white"} >LOGIN</button></Link>
                            </li>
                            <li>
                                <Link to={'/signup'}><button className="btn btn-small bg-green">DAFTAR</button></Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js